<template lang="pug">
  div
    doc-markdown(source=`
    ## Checkbox groups \`sw-checkbox-group\`
    This component enables to group multiple \`sw-checkbox\` components together. It acts as a parent wrapper that contains and shares the array of checked/unchecked values with its children \`sw-checkbox\` components that are passed in its slot.
    `)

    doc-preview(vue=`
    sw-checkbox-group(
      v-model='selectedArray'
    )
      sw-checkbox(
        v-for='information in multipleInformations'
        :key='information'
        :checkbox-value='information'
        custom-classes='flex max-w-xs rounded border border-green-200 py-3 my-3'
        checkbox-classes='w-6 h-6 p-3 mx-3 rounded-sm border flex items-center justify-center'
        checked-checkbox-classes='text-blue-500'
      )
        span(v-text='information')
        sw-icon(name='check' size='w-8 h-8' slot='checkedIcon')

    <script>
      ...
      data() {
        return {
          multipleInformations: ['information1', 'information2']
          selectedArray: []
        }
      }
    </script>
    `)
      sw-checkbox-group(
        v-model="selectedArray"
      )
        sw-checkbox(
          v-for="information in multipleInformations"
          :key="information"
          :checkbox-value="information"
          custom-classes="flex max-w-xs rounded border border-green-200 py-3 my-3"
          checkbox-classes="w-6 h-6 p-3 mx-3 rounded-sm border flex items-center justify-center"
          checked-checkbox-classes="text-blue-500"
        )
          span(v-text="information")
          sw-icon(name="check" size="w-8 h-8" slot="checkedIcon")

    doc-markdown(source=`
    ### Slots
  | Slot name | Description                                        |
  |-----------|----------------------------------------------------|
  | *default* | The \`sw-checkbox\` elements of the checkbox group |
    `)

    doc-markdown(source=`
    ### Properties
  | Props | Description                               | Type | Default  |
  |-------|-------------------------------------------|------|--------- |
  | value | Array of currently checked values | Array| [] |
    `)

    doc-markdown(id="events" source=`
    ### Events
  | Event name | Description                                         | Parameters                        | Usage      |
  |------------|-----------------------------------------------------|:--------------------------------: |------------|
  | input      | Triggered when clicked on a \`SwCheckbox\` children | Emits an array of checked values  | \`@input\` |
    `)

    doc-markdown(source=`
    ### Provide
    This wrapper \`provides\` both a \`checkboxGroupValueArray\` and a \`updateCheckboxGroupValueArray\`.
    The former is an array that is equal to the value of this element, containing all the currently checked values.
    The later is a function that will allow any children to add or remove values in that array when the checkbox is checked.
    `)
</template>
 <script>
 export default {
   data () {
     return {
       multipleInformations: ['information1', 'information2'],
       selectedArray: [],
     };
   },
 };
</script>
